export default {
  most_popular: '#{{rank}} Meest geliefd',
};
